document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.is-play').forEach((button) => {
        button.addEventListener('click', (event) => {
            const cardImage = event.target.closest('.card-image');
            const videoUrl = cardImage.getAttribute('data-video-url');

            cardImage.innerHTML = `
                <iframe 
                    width="1028" 
                    height="540" 
                    src="${videoUrl}" 
                    title="Video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin"
                    class="is-fullwidth is-fullheight" 
                    allowfullscreen>
                </iframe>
            `;
        });
    });
});
